export interface Retrofit {
  status: RetrofitStatus
  retrofitRecommendations: RetrofitRecommendation[]
  infinityOption?: InfinityOption
  configuration?: RetrofitConfiguration
  system?: RetrofitSystem
}

export enum RetrofitStatus {
  ok = 'OK',
  error = 'ERROR',
  unknown = 'UNKNOWN',
  notOkay = 'NOK',
}

export interface RetrofitSystem {
  serialnumber: number
  productName: string
}

export interface RetrofitConfiguration {
  currentBatteryCount: number
  capacity: number
  power: number
}

export type RetrofitRecommendationType = 'min' | 'recommended' | 'big'

export interface CabinetDimension {
  depth: number
  height: number
  width: number
}

export interface RetrofitRecommendation {
  cabinetDimension: CabinetDimension
  type: RetrofitRecommendationType
  maxBatteryCount: number
  addableBatteryCount: number
  numberExternalCabinets: number
  changeBatteryIndex: number
  capacity: number
  power: number
  info: 'infinity' | 'powerkit' | null
  expiresAt: Date
}

export interface InfinityOption {
  numberModules: number
  capacity: number
  power: number
  expiresAt: Date
}

export interface RetrofitListItem {
  serialnumber: number
  expiresAt: Date
}

export interface RetrofitPartnerContact {
  name: string
  email: string
  telephone: string
}
